/**
 * Application theme colors
 */
export const colors = {
  /** Background dark gray */
  bgColor: "#1e1e1e",
  /** Foreground white */
  fgColor: "white",
  /** Accent cyan */
  accent: "#31c4d8",
  /** Primary teal */
  primary: "#245056",
  /** Secondary gray */
  secondary: "#343434",
  /** Black */
  black: "black",
};
